/* eslint-disable max-len */
import { memo } from 'react';

import { IStylable } from './iconTypes';

function IAmEmployee({ style, className }: IStylable) {
  return (
    <svg
      width="111"
      height="91"
      viewBox="0 0 111 91"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <ellipse
        cx="44.9637"
        cy="44.1024"
        rx="44.9637"
        ry="44.1024"
        transform="matrix(-0.998578 -0.0533131 -0.217268 0.976112 110.414 4.83594)"
        fill="#7EFBB1"
      />
      <path
        d="M97.8128 74.3581C98.324 73.9642 98.7985 73.5058 99.2261 72.9823C102.137 69.4191 102.981 65.7598 102.627 62.3077C102.28 58.9249 100.796 55.8482 99.2512 53.3307C97.8697 51.0793 96.152 48.5801 94.1306 46.4445C92.2348 44.4415 89.9842 42.6647 87.3983 41.7754C86.3558 40.5961 85.2089 39.5385 83.9684 38.6519C81.3456 36.7774 76.7543 34.6757 71.7351 36.6033C69.4577 37.4779 66.728 39.2248 65.2468 42.4781C64.5465 44.0161 64.2853 45.5436 64.2977 46.9617C62.3895 48.4719 60.3198 50.9376 59.8671 54.4612C59.7258 55.561 59.7636 56.6034 59.9294 57.5746C58.9429 59.1206 58.1743 61.1582 58.3593 63.5712C58.6017 66.7321 60.3551 68.9724 61.9685 70.3105C63.9135 71.9237 66.3455 72.855 68.7167 73.3943C71.2023 75.5297 74.3251 77.2281 77.8715 78.2355C85.4998 80.4023 93.2873 78.8339 97.8128 74.3581Z"
        fill="white"
        stroke="#1D1D1D"
        strokeWidth="3.27846"
        strokeLinecap="round"
      />
      <path
        d="M77.8375 77.2147C82.9038 78.6538 87.9785 78.4157 92.1025 76.8086C96.2275 75.2013 99.4718 72.1853 100.643 68.0616C101.814 63.9379 100.64 59.6668 97.976 56.131C95.3126 52.596 91.1208 49.7257 86.0545 48.2866C80.9883 46.8476 75.9135 47.0857 71.7895 48.6927C67.6645 50.3001 64.4203 53.316 63.2489 57.4398C62.0776 61.5635 63.252 65.8345 65.916 69.3704C68.5795 72.9054 72.7712 75.7757 77.8375 77.2147Z"
        fill="white"
        stroke="#1D1D1D"
        strokeWidth="2.56931"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M78.8099 56.8153C76.2626 55.1406 73.4589 53.996 70.7295 53.676C68.1982 53.3791 64.4884 53.7125 61.972 56.6981C60.777 58.1159 59.6713 60.1968 59.8676 62.7555C60.0659 65.341 61.4991 67.2059 62.8888 68.3585C65.4253 70.4622 69.0679 71.3267 72.3665 71.6401C75.4647 71.9344 78.215 69.6614 78.5093 66.5631C78.5141 66.5124 78.5182 66.4618 78.5217 66.4112C78.4598 65.884 78.2876 64.7058 78.0934 64.2113C77.8993 63.7167 79.873 60.7181 80.8842 59.2806C80.4629 58.3072 79.7624 57.4415 78.8099 56.8153Z"
        fill="white"
        stroke="#1D1D1D"
        strokeWidth="2.56931"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75.9781 46.1535C79.0327 47.1693 81.9766 49.1484 84.5002 51.6747L82.6328 58.2487L81.8891 62.6126C81.8731 62.6698 81.8564 62.7269 81.8388 62.7839C80.7649 66.2676 77.0702 68.2212 73.5864 67.1472C69.8775 66.0039 65.905 64.1467 63.4955 61.1308C62.1755 59.4786 60.9748 56.9989 61.3618 53.9863C61.7448 51.0048 63.5076 48.8808 65.2152 47.5386C68.811 44.7122 73.1453 45.2115 75.9781 46.1535Z"
        fill="white"
        stroke="#1D1D1D"
        strokeWidth="2.56931"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M82.8843 39.2949C85.5032 41.1667 87.7321 43.9262 89.3981 47.0846C91.0989 50.309 89.8638 54.3017 86.6393 56.0025C85.6921 56.5022 84.6785 56.7485 83.6762 56.7654C83.6441 56.8152 83.6112 56.8648 83.5776 56.9141C81.5237 59.926 77.4171 60.7025 74.4052 58.6486C71.1987 56.4619 67.9509 53.5153 66.5385 49.9228C65.7647 47.9547 65.349 45.2311 66.6077 42.4667C67.8532 39.731 70.1642 38.2216 72.1918 37.4429C76.4614 35.8032 80.4555 37.5591 82.8843 39.2949Z"
        fill="white"
        stroke="#1D1D1D"
        strokeWidth="2.56931"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M83.7033 57.5275C82.6676 61.2063 80.0011 64.2377 75.7567 63.3771C72.1839 62.6527 69.8748 59.1692 70.5992 55.5964C71.5595 50.8603 75.3339 45.2308 79.4939 43.1819C87.4674 39.2547 93.8208 47.1517 97.7191 53.5048C100.702 58.3656 103.082 64.823 97.8217 71.262C92.6837 77.5517 79.6444 71.817 85.3708 59.9422C84.7658 58.9561 84.2012 58.1439 83.7033 57.5275Z"
        fill="white"
      />
      <path
        d="M83.7033 57.5276C82.6675 61.2064 80.0011 64.2378 75.7567 63.3772C72.1839 62.6528 69.8748 59.1693 70.5992 55.5965C71.5595 50.8604 75.3338 45.231 79.4938 43.182C87.4674 39.2548 93.8208 47.1518 97.7191 53.5049C100.702 58.3657 103.969 65.5654 98.7088 72.0044M83.7033 57.5276C83.9177 56.4458 84.3309 53.9344 84.2683 52.5443M83.7033 57.5276C82.3208 63.4265 84.2295 67.4852 86.7885 69.842C88.3189 71.2514 90.6058 71.8824 92.4914 71.9092"
        stroke="#1D1D1D"
        strokeWidth="2.56931"
        strokeLinecap="round"
      />
      <path
        d="M8.63927 30.3422C8.63164 29.6969 8.6975 29.0404 8.84344 28.3804C9.83689 23.8879 12.1863 20.9582 15.1152 19.0972C17.9853 17.2735 21.32 16.5322 24.253 16.185C26.8762 15.8744 29.9022 15.6742 32.8309 15.9377C35.5778 16.1848 38.3668 16.8505 40.6671 18.3293C42.2387 18.4169 43.7794 18.6618 45.2439 19.0862C48.3403 19.9836 52.8347 22.2853 54.4314 27.4193C55.1559 29.7487 55.4761 32.9737 53.8402 36.1521C53.0668 37.6547 52.0297 38.8061 50.9088 39.675C50.9057 42.1085 50.2527 45.2608 47.7674 47.7993C46.9917 48.5916 46.15 49.2078 45.285 49.6794C44.6827 51.4116 43.5595 53.2774 41.5509 54.6272C38.9196 56.3953 36.0747 56.4071 34.0247 55.9698C31.5534 55.4426 29.3156 54.1106 27.4231 52.5836C24.207 51.9556 20.939 50.5567 17.951 48.3972C11.5239 43.752 7.92992 36.6676 8.63927 30.3422Z"
        fill="white"
        stroke="#1D1D1D"
        strokeWidth="3.27846"
        strokeLinecap="round"
      />
      <path
        d="M18.7767 47.785C14.5082 44.6999 11.5509 40.5691 10.2571 36.3363C8.96302 32.1025 9.32024 27.6874 11.8313 24.213C14.3424 20.7386 18.4226 19.0141 22.8485 18.9145C27.2735 18.8149 32.1236 20.3268 36.3922 23.4118C40.6607 26.4969 43.618 30.6278 44.9118 34.8605C46.2058 39.0943 45.8486 43.5094 43.3375 46.9838C40.8264 50.4582 36.7463 52.1827 32.3203 52.2823C27.8954 52.3819 23.0452 50.87 18.7767 47.785Z"
        fill="white"
        stroke="#1D1D1D"
        strokeWidth="2.56931"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.1758 34.3901C37.0685 35.3518 39.7041 36.8434 41.6464 38.7875C43.4477 40.5905 45.4846 43.709 44.7002 47.534C44.3277 49.3504 43.3794 51.5076 41.2494 52.9389C39.0971 54.3852 36.7452 54.4156 34.9796 54.039C31.7566 53.3514 28.8212 51.0278 26.5315 48.6329C24.3809 46.3833 24.461 42.8162 26.7106 40.6656C26.7474 40.6303 26.7846 40.5957 26.8221 40.5617C27.2743 40.2836 28.3058 39.6888 28.8143 39.5348C29.3228 39.3808 30.4536 35.9737 30.9554 34.2894C31.9805 34.0169 33.094 34.0304 34.1758 34.3901Z"
        fill="white"
        stroke="#1D1D1D"
        strokeWidth="2.56931"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.3044 29.9941C41.6146 28.2258 38.2371 27.1413 34.6906 26.7257L30.6874 32.2646L27.7228 35.5522C27.6879 35.6001 27.6534 35.6486 27.6196 35.6978C25.5504 38.6992 26.3062 42.8096 29.3076 44.8788C32.503 47.0816 36.4222 49.0491 40.2823 49.0718C42.397 49.0842 45.0874 48.4903 47.2123 46.32C49.3152 44.1721 49.8902 41.4724 49.8858 39.3004C49.8764 34.7268 46.799 31.634 44.3044 29.9941Z"
        fill="white"
        stroke="#1D1D1D"
        strokeWidth="2.56931"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.4045 20.3353C42.3126 19.4393 38.7656 19.3995 35.2543 20.0487C31.6695 20.7115 29.3008 24.1548 29.9636 27.7396C30.1583 28.7927 30.593 29.7409 31.2007 30.5381C31.1815 30.5942 31.1629 30.6507 31.145 30.7076C30.0535 34.1859 31.9884 37.8904 35.4666 38.9819C39.1697 40.144 43.4949 40.8676 47.1898 39.7504C49.2141 39.1384 51.6095 37.7772 52.9995 35.0765C54.3751 32.4039 54.1281 29.6547 53.483 27.5807C52.1247 23.2134 48.2718 21.1662 45.4045 20.3353Z"
        fill="white"
        stroke="#1D1D1D"
        strokeWidth="2.56931"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.5895 30.976C28.3436 34.0683 27.6163 38.0395 30.9215 40.8378C33.7037 43.1934 37.8688 42.8475 40.2243 40.0653C43.3469 36.3772 45.4271 29.9266 44.4579 25.3918C42.6002 16.6999 32.4652 16.6058 25.0631 17.4821C19.3997 18.1525 12.8566 20.2854 11.0614 28.4036C9.30777 36.3336 21.8881 43.0154 27.661 31.1632C28.8098 31.0272 29.7971 30.9671 30.5895 30.976Z"
        fill="white"
      />
      <path
        d="M30.5894 30.9761C28.3436 34.0683 27.6162 38.0395 30.9214 40.8379C33.7037 43.1935 37.8687 42.8476 40.2243 40.0654C43.3468 36.3773 45.427 29.9267 44.4578 25.3919C42.6002 16.7 32.4651 16.6059 25.063 17.4822C19.3997 18.1526 11.7242 20.0492 9.929 28.1673M30.5894 30.9761C31.3058 30.1375 33.021 28.2572 34.1509 27.445M30.5894 30.9761C26.8158 35.7161 22.4474 36.7325 19.012 36.1841C16.9574 35.8561 15.0452 34.452 13.8559 32.9886"
        stroke="#1D1D1D"
        strokeWidth="2.56931"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default memo(IAmEmployee);
